/* eslint-disable no-underscore-dangle */
/* eslint-disable no-unused-vars */
import React, { useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import lottie from 'lottie-web';
import { Space, Typography, Row, Col, Button, message } from 'antd';
import EbzButton from 'components/EbzButton';
import EVENT_NAME from 'utils/const';
import trackingService from 'services/trackingService';
import EbzModal from 'components/EbzModal';
import merchantAPI from 'services/merchants';
import Alert from 'components/Alert';
import searchJson from '../../../assets/animation/search_empty.json';

function IncompleteKycModal({ kycModal, handleKycModal }) {
  // const containerRef = useRef(null);

  const kycVerify = async () => {
    message.info({
      content: 'Fetching Kyc verification link'
    });

    const response = await merchantAPI.partnerKycVerify();

    if (response.success) {
      window.open(response.data.redirection_url);
      message.info({
        content: 'You are being redirected to link'
      });
    } else {
      console.log('something went wrong');
      Alert('something went wrong', response?.data?.error?.message, 'error');
    }
  };

  const containerRef = useRef(null);

  /* eslint-disable consistent-return */
  useEffect(() => {
    let anim;
    if (kycModal) {
      // ⏳ Give AntD time to mount the modal content before initializing Lottie
      const timer = setTimeout(() => {
        if (containerRef.current) {
          anim = lottie.loadAnimation({
            container: containerRef.current,
            animationData: searchJson,
            renderer: 'svg',
            loop: true,
            autoplay: true
          });
        }
      }, 300); // wait ~300ms for modal transition

      // Cleanup
      return () => {
        clearTimeout(timer);
        if (anim) anim.destroy();
      };
    }
  }, [kycModal]);

  return (
    <EbzModal
      centered
      title={null}
      isOpen={kycModal}
      closable={false}
      toggleModal={() => handleKycModal(false)}
      afterOpenChange={(open) => {
        if (open) {
          lottie.loadAnimation({
            container: document.querySelector('#kyc-icon'),
            animationData: searchJson,
            renderer: 'svg',
            loop: true,
            autoplay: true
          });
        }
      }}
      width={700}
    >
      <Row gutter={[10, 10]} style={{ width: '100%', padding: '20px 0px' }}>
        <Col span={9} style={{ display: 'flex', justifyContent: 'center' }}>
          <div id="kyc-icon" ref={containerRef} style={{ width: '100%', height: '200px' }} />
        </Col>
        <Col span={15} style={{ display: 'flex', justifyContent: 'center' }}>
          <Space direction="vertical" size="large">
            <Typography.Text style={{ fontSize: '20px', fontWeight: '500' }}>
              Oh, no! Your KYC verification is pending
            </Typography.Text>
            <Typography.Text style={{ fontSize: '15px' }}>
              Your KYC is not approved. Please make sure your KYC is submitted and approved, before
              raising an invoice.
            </Typography.Text>
            <Space size="middle" style={{ width: '100%' }}>
              <Button
                type="primary"
                size="large"
                onClick={() => {
                  trackingService.trackEvent(EVENT_NAME, { name: 'Complete Kyc' });
                  kycVerify();
                  handleKycModal(false);
                }}
              >
                Complete KYC
              </Button>
              <EbzButton
                size="large"
                onClick={() => {
                  handleKycModal(false);
                }}
              >
                I&apos;ll do it Later
              </EbzButton>
            </Space>
          </Space>
        </Col>
      </Row>
    </EbzModal>
  );
}

IncompleteKycModal.propTypes = {
  kycModal: PropTypes.bool.isRequired,
  handleKycModal: PropTypes.func.isRequired
};

export default IncompleteKycModal;
